import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { AuthenticationComponent } from './authentication.component';
import { NgxSpinnerModule } from "ngx-spinner";


@NgModule({
  declarations: [AuthenticationComponent],
  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    NgxSpinnerModule
  ],
  exports:[AuthenticationComponent]
})
export class AuthenticationModule { }
